import BaseApiService from '@/services/common/api/baseApiService';

class ClientsService extends BaseApiService {
  getClients() {
    return this.makeRequest(this.httpClient.get(this.apiRoutes.clients));
  }
}

export default ClientsService;
